export default __webpack_public_path__ + "static/media/CorpayXAlpha.1ef9c9e4.png";